<footer class="e-footer" role="contentinfo" aria-label="Application footer">
    <div class="e-footer-content">
        <div>
            <span>&copy;{{ dateCurrentYear }} Euromonitor International</span>
            <span *ngIf="version">{{ version }}</span>

            <nav mat-tab-nav-bar role="navigation" aria-label="Footer links">
                <span><a mat-tab-link [routerLink]="contactRoute">Contact</a></span>
                <span><a mat-tab-link [href]="privacyPolicyLink" target="_blank" tabindex="-1">Privacy Policy</a></span>
                <!-- TODO: add cookie policy -->
                <!-- <span><a mat-tab-link tabindex="-1" (click)="openCookiePolicy()">Cookie Policy</a></span> -->
            </nav>
        </div>
        <div class="e-footer-logo">
            <a href="//www.euromonitor.com" target="_blank" aria-label="Click here to go to Euromonitor dot com"></a>
        </div>
    </div>
</footer>
